let PfChatbotChooseMainSymptomPlugin = {};

PfChatbotChooseMainSymptomPlugin.install = function (Vue, {router, store}) {

    let shouldApplyKeyboardFix = () => {
        // The fix depends on the visualViewport API.
        if (!window.visualViewport) return false;

        const ua = navigator.userAgent;

        // Android phone only ("Mobile" present; tablets omit it).
        const isAndroidPhone = /Android/.test(ua) && /Mobile/.test(ua);

        // Chrome ONLY — every other Chromium browser also has "Chrome/" in its UA,
        // so subtract them by their own tokens (Edge=Edg, Opera=OPR, etc.).
        const isChrome =
            /Chrome\//.test(ua) &&
            !/Edg|OPR|SamsungBrowser|Vivaldi|YaBrowser|UCBrowser|HuaweiBrowser|MiuiBrowser|DuckDuckGo|Firefox/.test(ua);

        return isAndroidPhone && isChrome;
    };

    let setScrollableContentHeight = () => {

        let scrollableElem;
        let scrollHeight;

        let elemMainSymptomPopup = document.querySelector('.choose-main-symptom-popup');
        let elemPopupHeader = document.querySelector('.choose-main-symptom-popup .choose-main-symptom-popup--header');
        let elemConversation = document.querySelector('.choose-main-symptom-popup .choose-main-symptom-popup--conversation');
        let elemTabsHeader = document.querySelector('.choose-main-symptom-popup .choose-main-symptom-popup--tabs-headers');

        let mainSymptomPopupTopSpace = parseInt(window.getComputedStyle(elemMainSymptomPopup).getPropertyValue('top')) || 0; // "|| 0" makes us sure that when there is no "top" property set, we don't get a "NaN" (Not-A-Number) value, but a numeric 0 instead of NaN.
        // ----------- "Search A Symptom" tab is active -----------

        let elemTabContent_Search = document.querySelector('.choose-main-symptom-popup .search-main-symptom-wrapper');
        if (elemTabContent_Search !== null) {

            let elemTabContent_Search_Input = document.querySelector('.choose-main-symptom-popup .search-main-symptom-wrapper .search-main-symptom--input-container');
            let elemTabContent_Search_Results = document.querySelector('.choose-main-symptom-popup .search-main-symptom-wrapper .search-main-symptom--results-container');
            let elemTabContent_Search_ConfirmBtnContainer = document.querySelector('.choose-main-symptom-popup .search-main-symptom-wrapper .search-main-symptom--confirm-btn-container');
            let elemTabContent_Search_ConfirmBtn = document.querySelector('.choose-main-symptom-popup .search-main-symptom-wrapper .search-main-symptom--confirm-btn-container .btn');

            scrollableElem = elemTabContent_Search_Results;
            const shouldApplyKeyboardFixResult = shouldApplyKeyboardFix();
            const visualHeight = shouldApplyKeyboardFixResult ? window.visualViewport.height:  elemMainSymptomPopup.offsetHeight;
            scrollHeight = visualHeight
                - mainSymptomPopupTopSpace
                - elemPopupHeader.offsetHeight
                - elemConversation.offsetHeight
                - elemTabsHeader.offsetHeight
                - elemTabContent_Search_Input.offsetHeight
                - (elemTabContent_Search_ConfirmBtn !== null ? elemTabContent_Search_ConfirmBtnContainer.offsetHeight : 0);

            scrollableElem.style.height = scrollHeight + 'px';
        }

        // ----------- "Chapter Tree (Navigate to Symptom)" tab is active -----------
        let elemTabContent_ChapterTree = document.querySelector('.choose-main-symptom-popup .chapter-tree-wrapper');
        if (elemTabContent_ChapterTree !== null) {

            let elemTabContent_ChapterTree_ChapterList = document.querySelector('.choose-main-symptom-popup .chapter-tree-wrapper .chapter-tree--chapter-list');
            let elemTabContent_ChapterTree_ConfirmBtnContainer = document.querySelector('.choose-main-symptom-popup .chapter-tree-wrapper .chapter-tree--confirm-btn-container');
            let elemTabContent_ChapterTree_ConfirmBtn = document.querySelector('.choose-main-symptom-popup .chapter-tree-wrapper .chapter-tree--confirm-btn-container .btn');

            scrollableElem = elemTabContent_ChapterTree_ChapterList;
            scrollHeight = elemMainSymptomPopup.offsetHeight
                - mainSymptomPopupTopSpace
                - elemPopupHeader.offsetHeight
                - elemConversation.offsetHeight
                - elemTabsHeader.offsetHeight
                - (elemTabContent_ChapterTree_ConfirmBtn !== null ? elemTabContent_ChapterTree_ConfirmBtnContainer.offsetHeight : 0);

            scrollableElem.style.height = scrollHeight + 'px';
        }
    };



    // ==================================
    // Export
    // ==================================

    Vue.mixin({
        computed: {
            PfChatbotChooseMainSymptomPlugin: () => {
                return {
                    setScrollableContentHeight: setScrollableContentHeight,
                    shouldApplyKeyboardFix: shouldApplyKeyboardFix
                }
            }
        }
    });


};

export default PfChatbotChooseMainSymptomPlugin;



// WEBPACK FOOTER //
// ./src/common/plugins/pathfinder/PfChatbotChooseMainSymptomPlugin.js